import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Shimmer } from "@/components/Shimmer";
import { fmtDateTime } from "@/lib/format";

export default function AuditPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setData(r.data)); }, []);

  return (
    <div className="p-8 max-w-[1100px]" data-testid="audit-page">
      <PageHeader
        eyebrow="Compliance"
        title="Audit Log"
        subtitle="Every write action through the console is recorded here. Append-only."
      />

      <div className="card-surface divide-y divide-border">
        {!data && [...Array(3)].map((_, i) => <div key={i} className="p-4"><Shimmer className="h-14" /></div>)}
        {data?.items?.length === 0 && (
          <div className="p-10 text-center text-sm text-muted-foreground">No audit entries yet.</div>
        )}
        {data?.items?.map((e, i) => (
          <div key={i} className="p-4 flex gap-4" data-testid={`audit-entry-${i}`}>
            <div className="font-mono text-xs text-muted-foreground w-40 shrink-0">{fmtDateTime(e.ts)}</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-baseline gap-2 flex-wrap">
                <span className="font-medium text-sm">{e.action}</span>
                <span className="font-mono text-xs text-muted-foreground">
                  {e.entity_type}:{e.entity_id}
                </span>
                <span className="font-mono text-xs text-zinc-700">by {e.actor_email}</span>
              </div>
              {(e.before || e.after) && (
                <div className="mt-2 grid grid-cols-2 gap-2">
                  <pre className="bg-rose-50 border border-rose-200 rounded p-2 text-[10px] overflow-auto max-h-32">{JSON.stringify(e.before, null, 2)}</pre>
                  <pre className="bg-emerald-50 border border-emerald-200 rounded p-2 text-[10px] overflow-auto max-h-32">{JSON.stringify(e.after, null, 2)}</pre>
                </div>
              )}
              {e.note && <div className="text-xs text-muted-foreground mt-1">{e.note}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
